import { Grid } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import MessageBox from "../chatBooking/MessageBox";
import MessageBoxAdmin from "./MessageBox";
import AllUsers from "./Users";

function Chat() {
  const { selectedChat } = useSelector((state) => state.activeChat);
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={3.5}>
        <AllUsers />
      </Grid>
      <Grid item xs={12} md={8.5} sx={{ display: { xs: "none", md: "block" } }}>
        {/* {selectedChat?.type == "admin" ? <MessageBoxAdmin /> : <MessageBox />} */}
        <MessageBoxAdmin />
      </Grid>
    </Grid>
  );
}

export default Chat;
